import { FC } from 'react';

import { IMultiLineFieldHelperTextProps } from './MultiLineFieldHelperText.types';

export const MultiLineFieldHelperText: FC<IMultiLineFieldHelperTextProps> = (props) => {
  const { hasError, errorText, helperText } = props;

  if (hasError) {
    return errorText;
  }

  if (helperText) {
    return helperText;
  }

  return null;
};
